import {
  gqlErrorToast
} from '../utils/graphql-errors'
import { isVsSignupClosedError } from '@/utils/vs-signup-policy'

export default {
  install (Vue, { toast }) {
    /**
     *
     * @param {function(): Promise<void>} promise
     * @param {{[errorCode: string]: (error: any) => any }} except
     */
    Vue.prototype.$showGqlError = async function (promise, except = {}) {
      try {
        const result = await (typeof promise === 'function' ? promise() : promise)
        return result
      } catch (e) {
        if (isVsSignupClosedError(e)) {
          if (this.$route.name !== 'signup-not-found') {
            await this.$router.replace({ name: 'signup-not-found' }).catch(() => {})
          }
          throw e
        }
        const exceptMessages = Object.keys(except)
        const { excluded } = gqlErrorToast(toast, e, exceptMessages)
        for (const key of Object.keys(excluded)) {
          except[key]?.(excluded[key], {
            toast: () => gqlErrorToast(toast, e)
          })
        }
        throw e
      }
    }
  }
}
